import React from 'react';

import styled from 'styled-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import noop from 'utils/noop';

import theme from './theme';

const CardLink = styled.a`
  text-decoration: none;
  display: flex;
  flex-direction: column;
  background: ${Styles.color.white};
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  flex-grow: 1;
  padding: 4.375rem 2.5rem 3.75rem;
  align-items: center;
  ${Styles.mobile`
    padding: 3rem 2rem;
  `}
`;

const Heading = styled.h3`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  // This is a one-off custom font size
  font-size: 2.25rem;
  line-height: 1;
  margin: 1rem auto;
  text-transform: ${Styles.textTransform.headlines};
`;

const Description = styled.p`
  flex-grow: 1;
  color: ${theme.descriptionColor};
  margin: 0 auto 3rem;
  max-width: 30rem;
  text-align: center;
`;

interface IOurServicesCardProps {
  icon: React.ReactNode;
  testId: string;
  title: string;
  description: string;
  disabled: boolean;
  actionText: string;
  onClick: React.ReactEventHandler;
}

const OurServicesCard: React.FC<IOurServicesCardProps> = ({
  icon,
  title,
  description,
  disabled,
  actionText,
  testId,
  onClick,
}) => (
  <CardLink onClick={disabled ? noop : onClick} data-testid={testId}>
    {icon}
    <Heading>{title}</Heading>
    <Description>{description}</Description>
    <ActionButton
      fullWidth
      variant={ActionButtonVariants.OUTLINE}
      aria-label={`${title} ${actionText}`}
      disabled={disabled}
    >
      {actionText}
    </ActionButton>
  </CardLink>
);

export default OurServicesCard;
